import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02b2a509"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "visually-hidden" }, "Indisch Monument", -1))
const _hoisted_2 = {
  key: 0,
  class: "home-intro"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Welcome = _resolveComponent("Welcome")!
  const _component_CanvasIntroduction = _resolveComponent("CanvasIntroduction")!
  const _component_Canvas = _resolveComponent("Canvas")!
  const _component_KeyboardNavHint = _resolveComponent("KeyboardNavHint")!
  const _component_NewMelati = _resolveComponent("NewMelati")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.home)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.isIntro)
                ? (_openBlock(), _createBlock(_component_Welcome, { key: 0 }))
                : (_ctx.isQuotes || _ctx.isCounter)
                  ? (_openBlock(), _createBlock(_component_CanvasIntroduction, { key: 1 }))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Canvas, {
      "new-melati": !!_ctx.$route.query.melatiId,
      locked: !_ctx.canvasReadyToReceiveEvents
    }, null, 8, ["new-melati", "locked"]),
    _createVNode(_component_KeyboardNavHint),
    (_ctx.openOverlay)
      ? (_openBlock(), _createBlock(_component_NewMelati, {
          key: 1,
          onClose: _ctx.close,
          id: _ctx.$route.query.melatiId
        }, null, 8, ["onClose", "id"]))
      : _createCommentVNode("", true)
  ]))
}